import { createActionGroup, emptyProps } from '@ngrx/store';

import { ActionSource } from '../../../state/action-sources';

export const DiscardOpportunityDialogActions = createActionGroup({
  source: ActionSource.DISCARD_OPPORTUNITY_DIALOG,
  events: {
    'Discard Unsaved Changes Button Clicked': emptyProps(),
    },
  },
);
